import { OperationVariables, ApolloQueryResult } from '@apollo/client'
import { Checkbox, IconButton, Typography } from '@material-ui/core'
import RefreshIcon from '@material-ui/icons/Refresh'
import React from 'react'

import { getTranslate } from '../../localization'
import { BookingPermission } from '../../types/bookingPermission'
import useStyles from './styles/BookingPermissionTableHeader'

type BookingPermissionTableHeaderProps = {
  data: BookingPermission[]
  setData: React.Dispatch<React.SetStateAction<BookingPermission[]>>
  editMode: boolean
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      tenantBookingPermission: BookingPermission[]
    }>
  >
}

const BookingPermissionTableHeader = ({
  data,
  setData,
  editMode,
  refetch
}: BookingPermissionTableHeaderProps) => {
  const classes = useStyles()

  const isCheckedAllowOperation = data.every((ele) => ele.allowOperation)
  const isIndeterminateAllowOperation =
    data.some((ele) => ele.allowOperation) && !isCheckedAllowOperation

  const isCheckedAllowDiscount = data.every((ele) => ele.allowDiscount)
  const isIndeterminateAllowDiscount =
    data.some((ele) => ele.allowDiscount) && !isCheckedAllowDiscount

  return (
    <div className={classes.root}>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Accommodation Name')}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text} variant="body1">
          {getTranslate('Reservation Type')}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text}>
          {getTranslate('Channel Type')}
        </Typography>
      </div>
      <div>
        <Typography className={classes.text}>
          {getTranslate('Action Type')}
        </Typography>
      </div>
      {editMode ? (
        <div className={classes.textWithCheckBox}>
          <Checkbox
            checked={isCheckedAllowOperation}
            indeterminate={isIndeterminateAllowOperation}
            onChange={() => {
              setData((prevData) =>
                prevData.map((item) => ({
                  ...item,
                  allowOperation: !isCheckedAllowOperation
                }))
              )
            }}
            color="primary"
            classes={{
              root: classes.checkBoxPadding
            }}
          />
          <Typography className={classes.text} variant="body1">
            {getTranslate('Allow Operation')}
          </Typography>
        </div>
      ) : (
        <div>
          <Typography className={classes.text} variant="body1">
            {getTranslate('Allow Operation')}
          </Typography>
        </div>
      )}
      {editMode ? (
        <div className={classes.textWithCheckBox}>
          <Checkbox
            checked={isCheckedAllowDiscount}
            indeterminate={isIndeterminateAllowDiscount}
            onChange={() => {
              setData((prevData) =>
                prevData.map((item) => ({
                  ...item,
                  allowDiscount: !isCheckedAllowDiscount
                }))
              )
            }}
            color="primary"
            classes={{
              root: classes.checkBoxPadding
            }}
          />
          <Typography className={classes.text} variant="body1">
            {getTranslate('Allow Discount')}
          </Typography>
        </div>
      ) : (
        <div>
          <Typography className={classes.text} variant="body1">
            {getTranslate('Allow Discount')}
          </Typography>
        </div>
      )}
      <div className={classes.icon}>
        <IconButton
          onClick={() => {
            refetch()
          }}>
          <RefreshIcon />
        </IconButton>
      </div>
    </div>
  )
}

export default BookingPermissionTableHeader
